import React, { useCallback, useContext } from 'react';
import BonusPeriodsContext from '../../../contexts/BonusPeriodsContext';
import OpenPopupEntityAppContext from '../../../contextProviders/SplashScreenProviders/MiscProviders/PopupEntityAppProvider/OpenPopupEntityAppContext';
import LinkButton from './LinkButton';

const V3Link = ({
  app,
  entity,
  entityPrimaryFieldValue,
  tooltip,
  trackOnClick,
}: {
  app: EntityDetails.App;
  entity: EntityDetails.Entity;
  entityPrimaryFieldValue: string;
  tooltip: string;
  trackOnClick: () => void;
}) => {
  const { openEntityPopup } = useContext(OpenPopupEntityAppContext);
  const { selectedBonusPeriod } = useContext(BonusPeriodsContext);
  const onClick = useCallback(() => {
    trackOnClick();
    openEntityPopup({
      app,
      entity,
      entityValue: entityPrimaryFieldValue,
      selectedBonusPeriodId: selectedBonusPeriod?.id,
    });
  }, [
    app,
    entity,
    entityPrimaryFieldValue,
    openEntityPopup,
    selectedBonusPeriod,
    trackOnClick,
  ]);

  return <LinkButton onClick={onClick} tooltip={tooltip} />;
};

export default V3Link;
